import { OutlinedInput, Tooltip } from '@material-ui/core'
import AppBar from '@material-ui/core/AppBar'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import IconButton from '@material-ui/core/IconButton'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import Toolbar from '@material-ui/core/Toolbar'
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined'
import { DocumentationUserAuthentication } from '../../containers/AuthContainer'
import { USER_OBJECTID } from '../../constants/cookies'
import { DOC_URL } from '../../constants/url'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import MenuIcon from '@material-ui/icons/Menu'
import PowerSettingsNew from '@material-ui/icons/PowerSettingsNew'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import { makeStyles } from '@material-ui/styles'
import Access from '../../containers/RoleContainer'
import React, { useContext, useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'
import Cookies from 'js-cookie'
import { useTranslation } from 'react-i18next'
import { Redirect } from 'react-router-dom'
import ROLES, { ALL_ROLES } from '../../constants/roles'
import {
	ACCOUNT_ID_COOKIE,
	ACCOUNT_TYPES_COOKIE,
	ACTIVE_ACCOUNT_TYPE_COOKIE,
	FIRST_NAME_COOKIE,
	LAST_NAME_COOKIE,
	PLATFORM_ID_COOKIE,
	DEFAULT_COOKIE_OPTIONS,
	SHAREPOINT_URL_LIVE_COOKIE,
	SHAREPOINT_URL_SANDBOX_COOKIE,
	COMPANIES_COOKIE,
	COMPANY_ID_COOKIE,
	CAN_USE_CONVOCATION
} from '../../constants/cookies'
import { bindParams } from '../../utils/Link'
import { GETPLATFORMS, SHAREPOINT_URL, DOCUMENTATION_HELP, PLATFORM_CONFIGURATION_SPECIFIC } from '../../constants/url'
import { findRoleById } from '../../constants/roles'
import { REQUIRED_COOKIES, resetAllRequiredCookies } from '../../containers/CookieContainer'
import { getAccountInfosById, changeActiveRole, getSharePointIsActive } from '../../containers/DataContainer'
import { MenuContext } from '../../contexts/MenuContext'
import api from '../../utils/Requester'
import { setPlatforms } from '../../store/platforms/platformsSlice'
import { setRoles } from '../../store/roles/rolesSlice'
import { setCompanies } from '../../store/companies/companiesSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import { jwtDecode } from 'jwt-decode'
import { store } from '../../store/store'
import { mdiConsoleLine } from '@mdi/js'

// STYLES
const useStyles = makeStyles((theme) => ({
	appBar: {
		zIndex: theme.zIndex.drawer + 1,
		backgroundColor: theme.palette.primary.main,
	},
	totalIconButton: {
		marginLeft: theme.spacing.unit * -2 - 5,
		color: theme.palette.secondary.main,
	},
	paper: {
		position: 'fixed',
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
		outline: 'none',
		right: 30,
		top: 10,
	},
	logout: {
		color: theme.palette.secondary.main,
	},
	profil: {
		color: theme.palette.secondary.main,
	},
	flag: {
		width: 33,
		margin: theme.spacing.unit,
		cursor: 'pointer',
	},
	langContainer: {
		margin: theme.spacing.unit,
		display: 'flex',
		alignItems: 'center',
	},
	roles: {
		paddingLeft: theme.spacing.unit,
		paddingRight: theme.spacing.unit,
	},
	logo: {
		height: 60,
		padding: '0 8px',
	},
	helpButton: {
		color: theme.palette.secondary.main,
		padding: '2px',
		'& svg': {
			fontSize: '2rem',
		}
	},
	envText: {
		color: theme.palette.secondary.main,
		marginLeft: theme.spacing.unit,
		fontWeight: 'bold',
		flexGrow: 1,
	},
	selectForm: {
		marginLeft: theme.spacing.unit,
		minWidth: 60
	},
	roleSelection: {
		'& div': {
			'& div': {
				alignItems: 'center',
				padding: '14px'
			}
		}
	},
	roleIcon: {
		width: '24px',
		height: '24px'
	},
	menuItem: {
		display: 'flex',
		alignItems: 'center',
		gap: '16px'
	},
	formControl: {
		marginLeft: theme.spacing.unit,
		minWidth: 60,
		maxWidth: 400,
		'& .MuiSelect-select': {
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
		}
	}
}))

function TotalAppBar() {
	// STYLES
	const classes = useStyles()

	// STATES
	const [rapsoImg, setRapsoImg] = useState('/images/rapsod.png')
	const [clickCount, setClickCount] = useState(0)
	const [platform, setPlatform] = useState(null)
	const [profile, setProfile] = useState('ANONYMOUS.X')
	const [redirect] = useState({ active: false, path: '/' })
	const reduxDispatch = useDispatch()
	const platforms = useSelector((state) => state.platforms.platforms)
	const roles = useSelector((state) => state.roles.roles)?.accountTypes
	const companies = useSelector((state) => state.companies.companies)
	const [selectedRole, setSelectedRole] = useState('')
	const [company, setCompany] = useState(null)
	const [aideSharePointURL, setAideSharePointURL] = useState('')

	// eslint-disable-next-line no-unused-vars
	const [cookies, setCookie] = useCookies()

	// CONTEXTS
	const { open, dispatch } = useContext(MenuContext)

	// i18n
	const { t, i18n } = useTranslation(['user'])
	const { enqueueSnackbar } = useSnackbar()

	useEffect(() => {
		getSharePointIsActive(cookies[PLATFORM_ID_COOKIE], (response, error) => {
			if (error) {
				console.error(error)
				return
			}
			setAideSharePointURL(response.data.aideUrl)
		})
	}, [cookies[PLATFORM_ID_COOKIE]])

	// Helper function to truncate long company names
	const truncateCompanyName = (name, maxLength = 20) => {
		if (!name || name.length <= maxLength) return name
		return name.substring(0, maxLength) + '...'
	}

	const getAssignedPlatforms = (p_AccountId) => api.get(GETPLATFORMS, { p_AccountId })

	const handlePlatformResp = (res, companyPlatforms) => {
		const { ok, data } = res
		if (!ok) return
		if (companyPlatforms !== null) {
			let filteredPlatforms = data.filter(ptf => companyPlatforms.includes(ptf.platformId)).sort((ptf1, ptf2) => ptf1.platformId < ptf2.platformId)
			reduxDispatch(setPlatforms(filteredPlatforms))
		}
		else {
			reduxDispatch(setPlatforms(data.map((platform) => platform)))
		}
	}

	const getSharePointURL = (cookieOptions, platformId) => {
		api.get(SHAREPOINT_URL, { p_PlatformId: platformId }).then((res) => {
			const { ok, data } = res
			if (!ok) return
			if (data.length) {
				let live_url = data.filter((obj) => obj.environment === 'live')[0].url
				let sandbox_url = data.filter((obj) => obj.environment === 'sandbox')[0].url

				setCookie(SHAREPOINT_URL_LIVE_COOKIE, live_url, cookieOptions)
				setCookie(SHAREPOINT_URL_SANDBOX_COOKIE, sandbox_url, cookieOptions)
			}
		})
	}

	useEffect(() => {
		if (!cookies[ACCOUNT_ID_COOKIE]) return
		getAccountInfosById(cookies[ACCOUNT_ID_COOKIE], (res, err) => {
			if (err || !res || !res.data) {
				return
			}

			// Companies
			let defaultCompany = cookies[COMPANY_ID_COOKIE]
			let companyPlatforms = null
			if (defaultCompany && defaultCompany !== "-1") {
				setCookie(COMPANIES_COOKIE, JSON.stringify(res.data.companies), DEFAULT_COOKIE_OPTIONS)
				reduxDispatch(setCompanies(res.data.companies))
				setCompany(defaultCompany)
				companyPlatforms = res.data.companies.find(cp => cp.id.toString() === defaultCompany).platforms
			}
			getAssignedPlatforms(cookies[ACCOUNT_ID_COOKIE]).then(platformRes => handlePlatformResp(platformRes, companyPlatforms))
			let defaultPlatform = res.data.accountTypePerPlatform.find(
				(x) => x.platformId === +cookies[PLATFORM_ID_COOKIE],
			)
			if (defaultPlatform.accountTypes && defaultPlatform.accountTypes.length > 0) {
				try {
					const activeRoleCookie = cookies[ACTIVE_ACCOUNT_TYPE_COOKIE]
					const parsedActiveRole = typeof activeRoleCookie === 'string'
						? JSON.parse(activeRoleCookie)
						: activeRoleCookie

					const roleExists = parsedActiveRole && defaultPlatform.accountTypes.some(
						role => role.id === parsedActiveRole.id
					)

					if (roleExists) {
						setSelectedRole(parsedActiveRole.id)
					} else {
						setSelectedRole(defaultPlatform.accountTypes[0].id)
						setCookie(
							ACTIVE_ACCOUNT_TYPE_COOKIE,
							JSON.stringify(defaultPlatform.accountTypes[0]),
							DEFAULT_COOKIE_OPTIONS
						)
					}
				} catch (error) {
					setSelectedRole(defaultPlatform.accountTypes[0].id)
					setCookie(
						ACTIVE_ACCOUNT_TYPE_COOKIE,
						JSON.stringify(defaultPlatform.accountTypes[0]),
						DEFAULT_COOKIE_OPTIONS
					)
				}
			}

			setCookie(PLATFORM_ID_COOKIE, defaultPlatform.platformId, DEFAULT_COOKIE_OPTIONS)
			updateConvocationCookie(defaultPlatform.platformId)
			setCookie(
				ACCOUNT_TYPES_COOKIE,
				JSON.stringify(defaultPlatform.accountTypes),
				DEFAULT_COOKIE_OPTIONS,
			)

			reduxDispatch(setRoles(defaultPlatform))
			setPlatform(defaultPlatform.platformId)
			if (
				(cookies[ACTIVE_ACCOUNT_TYPE_COOKIE]?.code === 'ADMIN' ||
					cookies[ACTIVE_ACCOUNT_TYPE_COOKIE]?.code === 'PLATFORMMANAGER')
			)
				getSharePointURL(DEFAULT_COOKIE_OPTIONS, defaultPlatform.platformId)
		})


		const decoded = jwtDecode(store.getState().token.token)
		if (decoded.idp_access_token !== undefined) {
			let exp = jwtDecode(decoded.idp_access_token).exp
			if (exp < Date.now() / 1000) {
				enqueueSnackbar(t('ExpiredToken'), { variant: 'info' })
			}
		}
		setProfile(formatProfile(cookies[FIRST_NAME_COOKIE], cookies[LAST_NAME_COOKIE]))
	}, [])

	// EVENTS
	const toggleMenu = () => {
		if (open) dispatch({ type: 'close' })
		else dispatch({ type: 'open' })
	}

	const disconnect = () => {
		resetAllRequiredCookies(REQUIRED_COOKIES)
		window.location.href = window.location.href + '?disconnect'
	}

	const changeCompany = (e) => {
		let companyId = e.target.value
		setCompany(companyId)
		setCookie(COMPANY_ID_COOKIE, companyId, DEFAULT_COOKIE_OPTIONS)
		let allCompanies = cookies[COMPANIES_COOKIE]
		let selectedCompany = allCompanies.find((cp) => cp.id === companyId)
		if (!selectedCompany.platforms.map(p => p.toString()).includes(cookies[PLATFORM_ID_COOKIE].platformId)) {
			let companyPlatform = selectedCompany.platforms.sort((p1, p2) => p1 < p2)[0];
			setCookie(PLATFORM_ID_COOKIE, companyPlatform || null, DEFAULT_COOKIE_OPTIONS)
			updateConvocationCookie(companyPlatform)
		}

		window.location.href = "/"
	}


	const changePlatform = (e) => {
		let platformId = e.target.value

		getAccountInfosById(cookies[ACCOUNT_ID_COOKIE], (res, err) => {
			if (err) {
				return
			}

			let selectedPlatform = res.data.accountTypePerPlatform.find(
				(x) => x.platformId === +platformId,
			)
			setCookie(PLATFORM_ID_COOKIE, platformId, DEFAULT_COOKIE_OPTIONS)
			updateConvocationCookie(platformId)
			setCookie(
				ACCOUNT_TYPES_COOKIE,
				JSON.stringify(selectedPlatform.accountTypes),
				DEFAULT_COOKIE_OPTIONS,
			)

			const currentActiveRole = cookies[ACTIVE_ACCOUNT_TYPE_COOKIE]
				? typeof cookies[ACTIVE_ACCOUNT_TYPE_COOKIE] === 'string'
					? JSON.parse(cookies[ACTIVE_ACCOUNT_TYPE_COOKIE])
					: cookies[ACTIVE_ACCOUNT_TYPE_COOKIE]
				: null

			const roleExists = currentActiveRole && selectedPlatform.accountTypes.some(
				role => role.id === currentActiveRole.id
			)

			const activeRole = roleExists
				? currentActiveRole
				: selectedPlatform.accountTypes[0]

			setCookie(
				ACTIVE_ACCOUNT_TYPE_COOKIE,
				JSON.stringify(activeRole),
				DEFAULT_COOKIE_OPTIONS,
			)
			setSelectedRole(activeRole.id)
			setPlatform(platformId)

			const userId = cookies[ACCOUNT_ID_COOKIE]
			const roleId = activeRole.id
			changeActiveRole(userId, platformId, roleId, () => {
				window.location.href = "/"
			})
		})
	}

	const handleRoleChange = (event) => {
		setSelectedRole(event.target.value)
		if (roles && roles.length > 0) {
			const activeRole = roles.find(r => r.id === event.target.value)
			if (activeRole) {
				setCookie(
					ACTIVE_ACCOUNT_TYPE_COOKIE,
					JSON.stringify(activeRole),
					DEFAULT_COOKIE_OPTIONS,
				)
				const userId = cookies[ACCOUNT_ID_COOKIE]
				const platformId = cookies[PLATFORM_ID_COOKIE]
				const roleId = activeRole.id
				changeActiveRole(userId, platformId, roleId, () => {
					window.location.href = "/"
				})
			}
		}
	}

	const updateConvocationCookie = (platformId) => {
		const translationCode = 'CanUseConvocation'
		api
			.get(
				bindParams(PLATFORM_CONFIGURATION_SPECIFIC, platformId, translationCode),
			)
			.then(res => {
				const { data, ok, originalError } = res

				if (originalError && originalError.code === 'ECONNABORTED') return

				if (!ok) return enqueueSnackbar(t('view_render_failed'), { variant: 'error' })
				if (data) {
					setCookie(CAN_USE_CONVOCATION, data.value, DEFAULT_COOKIE_OPTIONS)
				}
			})
	}

	const LangSelector = () => {
		const changeLanguage = (lang) => {
			switch (lang) {
				case 'fr':
					i18n.changeLanguage('fr')
					break
				case 'en':
					i18n.changeLanguage('en')
					break
				default:
					break
			}
		}

		return (
			<div className={classes.langContainer}>
				<img
					onClick={() => changeLanguage('fr')}
					src="/images/fr.png"
					alt="fr"
					className={classes.flag}
				/>
				<img
					onClick={() => changeLanguage('en')}
					src="/images/en.png"
					alt="en"
					className={classes.flag}
				/>
			</div>
		)
	}

	const formatProfile = (firstName, lastName) => firstName + '.' + lastName.substring(0, 1)

	const onImgClick = () => {
		if (clickCount >= 5) setRapsoImg('/images/rapsod1.png')
		else setClickCount(clickCount + 1)
	}

	const handleClickAuthenticationDocumentation = (url) => {
		DocumentationUserAuthentication(cookies[PLATFORM_ID_COOKIE], (response, error) => {
			if (error) {
				console.error(error)
				return
			}

			if (response.data)
				Cookies.set(USER_OBJECTID, response.data.UserUUID, {
					...DEFAULT_COOKIE_OPTIONS,
				})
			window.open(url, '_blank')
		})
	}

	const isProd = window.location.hostname.includes('rapso-d.totalenergies.com')

	if (redirect.active) return <Redirect to={redirect.path} />
	else
		return (
			<AppBar position="fixed" className={classes.appBar}>
				<Toolbar>
					<IconButton
						color="primary"
						aria-label="Open drawer"
						onClick={toggleMenu}
						className={classes.totalIconButton}
					>
						{open ? <KeyboardArrowLeftIcon /> : <MenuIcon />}
					</IconButton>
					<a href="/">
						<img src="/images/total.png" alt={t('brand')} className={classes.logo} />
					</a>
					<span className={classes.AppImage}>
						<img src={rapsoImg} alt={t('title')} className={classes.logo} onClick={onImgClick} />
					</span>
					{!isProd && <span className={classes.envText}>{t('preProdTitle')}</span>}
					<LangSelector />
					{<Access accept={[ROLES.EXTCOMPADMIN, ROLES.EXTCOMP]}>
						<form className={classes.root} autoComplete="off">
							<FormControl variant="outlined" className={classes.formControl}>
								<Select
									value={company !== null && company}
									inputProps={{
										name: 'company',
										id: 'company',
									}}
									onChange={changeCompany}
									input={<OutlinedInput name="company" labelWidth={0} />}
								>
									{companies &&
										Object.keys(companies).map((key) => companies[key]).map(
											(cp) => cp.id && (
												<MenuItem key={cp.id} value={cp.id}>
													{cp.nom}
												</MenuItem>
											)
										)
									}
								</Select>
							</FormControl>
						</form>
					</Access>}
					<form className={classes.root} autoComplete="off">
						<FormControl variant="outlined" className={classes.selectForm}>
							<Select
								value={platform !== null && platform}
								inputProps={{
									name: 'platform',
									id: 'platform',
								}}
								onChange={changePlatform}
								input={<OutlinedInput name="platform" labelWidth={0} />}
							>
								{platforms &&
									platforms.map(
										(plf) =>
											plf.platformId && (
												<MenuItem key={plf.platformId} value={plf.platformId}>
													{plf.name}
												</MenuItem>
											),
									)}
							</Select>
						</FormControl>
					</form>
					<form className={classes.root} autoComplete="off">
						<FormControl variant="outlined" className={classes.selectForm}>
							<Select
								value={selectedRole}
								className={classes.roleSelection}
								onChange={handleRoleChange}
								input={<OutlinedInput labelWidth={0} />}
								renderValue={(value) => {
									const currentRole = findRoleById(value)[0]
									return <img className={classes.roleIcon} src={currentRole.icon} alt={currentRole.name} />
								}}
							>
								{roles && roles.map((role) => {
									let currentRole = findRoleById(role.id)[0]
									return (
										<MenuItem className={classes.menuItem} key={role.id} value={role.id}>
											<img className={classes.roleIcon} src={currentRole.icon} alt={role.name} />
											{t(role.name)}
										</MenuItem>
									)
								})}
							</Select>
						</FormControl>
					</form>
					<Button disabled color="secondary">
						<AccountCircleOutlinedIcon className={classes.profil} />
						<span className={classes.profil}>&nbsp;{profile}</span>
					</Button>
					<Button onClick={disconnect} color="secondary" className={classes.logout}>
						<PowerSettingsNew className={classes.logout} />
						{t('logout')}
					</Button>
					<IconButton
						className={classes.helpButton}
						onClick={() => {
							if (aideSharePointURL === '') {
								handleClickAuthenticationDocumentation(
									`${DOC_URL + cookies[PLATFORM_ID_COOKIE]}/Aide?p_viewmode=live`,
								)
							}
							else {
								window.open(aideSharePointURL, '_blank')
							}
						}}
					>
						<HelpOutlineIcon />
					</IconButton>
				</Toolbar>
			</AppBar>
		)
}

export default TotalAppBar